import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { actions } from 'state';
import { SpotlightLogoIcon } from 'icons';
import { useUser } from 'libs';
import JoinRequest from './JoinRequest';
import FreeTrial from './FreeTrial';

const OnboardingModal = () => {
  const dispatch = useDispatch() as (action: unknown) => Promise<{ type: string }>;
  const user = useUser();
  const [showModal, setShowModal] = useState(!user.features.has_onboarded);
  const [page, setPage] = useState(1);
  const totalPages = 2;

  const nextStep = async () => {
    await dispatch(actions.users.fetchMe());

    if (page < totalPages) {
      setPage((currentPage) => Math.min(currentPage + 1, totalPages));
      return;
    }

    await markUserOnboarded();
  };

  const markUserOnboarded = async () => {
    const action = await dispatch(actions.users.markAsOnboarded());
    if (action.type === actions.users.actionTypes.updateFailed) {
      toast.error('Onboarding process not finished properly. Please contact support if this problem persists.');
      return;
    }

    await dispatch(actions.users.fetchMe());
  };

  useEffect(() => {
    if (user.features.has_onboarded) {
      setShowModal(false);
    }
  }, [user.features.has_onboarded]);

  return (
    <Modal
      backdrop="static"
      centered
      className="modal__single-section"
      keyboard={false}
      scrollable={false}
      show={showModal}
    >
      <Modal.Header className="bg-primary d-block">
        {totalPages > 1 && (
          <div
            className="d-flex fw-bold justify-content-end pt-4 px-4 text-white"
            data-testid="onboarding-modal-page-indicator"
          >
            {`${page}/${totalPages}`}
          </div>
        )}
        <div className="block mb-3 text-center text-white" data-testid="onboarding-modal-header">
          <SpotlightLogoIcon className="mb-2 text-spotlight-yellow w-10" />
          <h4 className="fw-bold">Welcome to Lender Spotlight</h4>
        </div>
      </Modal.Header>
      <Modal.Body>
        {page === 1 && <JoinRequest nextStep={nextStep} />}
        {page === 2 && <FreeTrial nextStep={nextStep} />}
      </Modal.Body>
    </Modal>
  );
};

export default OnboardingModal;
